import PropTypes from 'prop-types';
import React from 'react';
import { AddInsurance } from './components/AddInsurance';
import { Insurances } from './components/Insurances';
import './stylesheets/InsuranceInformation.scss';
export var InsuranceInformation = function InsuranceInformation(_ref) {
  var contact = _ref.contact,
    lastUpdate = _ref.lastUpdate,
    shouldShowLastUpdate = _ref.shouldShowLastUpdate;
  return /*#__PURE__*/React.createElement("div", {
    className: "profile-panel insurance-information"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "insurance-information__header",
    "data-testid": "insurance-information-header"
  }, /*#__PURE__*/React.createElement("h3", null, "Insurance"), /*#__PURE__*/React.createElement("div", {
    className: "section-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "add-insurance-information__section"
  }, /*#__PURE__*/React.createElement(AddInsurance, {
    contactId: contact.id
  })))), /*#__PURE__*/React.createElement(Insurances, {
    contact: contact,
    lastUpdate: lastUpdate,
    shouldShowLastUpdate: shouldShowLastUpdate
  })));
};
InsuranceInformation.propTypes = {
  contact: PropTypes.object.isRequired,
  lastUpdate: PropTypes.object,
  shouldShowLastUpdate: PropTypes.bool
};
InsuranceInformation.defaultProps = {
  lastUpdate: {
    recently_updated_by_name: null,
    recently_updated_at: null
  },
  shouldShowLastUpdate: false
};
//# sourceMappingURL=InsuranceInformation.js.map